import { Caption, UIHeading3 } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './Slide.css';

/**
 * @description Пропсы слайда.
 * @param imageUrl - URL изображения.
 * @param title - Заголовок слайда.
 * @param description - Описание слайда.
 * @example
 * <Slide imageUrl="https://example.com/image.jpg" title="Заголовок" description="Описание" />
 */
type SlideProps = {
  /**
   * @description URL изображения.
   */
  imageUrl: string;
  /**
   * @description Заголовок слайда.
   */
  title: string;
  /**
   * @description Описание слайда.
   */
  description: string;
};

/**
 * @description Слайд.
 * @param imageUrl - URL изображения.
 * @param title - Заголовок слайда.
 * @param description - Описание слайда.
 */
export const Slide: FC<SlideProps> = ({ imageUrl, title, description }) => {
  return (
    <div className={styles['slide']} data-testid="slider-block-type-one-slide">
      <div className={styles['slide-content']}>
        <UIHeading3 data-testid="slider-block-type-one-slide-title">{title}</UIHeading3>
        <Caption data-testid="slider-block-type-one-slide-description">{description}</Caption>
      </div>
      <img
        alt={title}
        className={styles['image']}
        data-testid="slider-block-type-one-slide-image"
        decoding="async"
        loading="lazy"
        src={imageUrl}
      />
    </div>
  );
};
